
const greekCapitals = [
    "Αγρίνιο",
    "Άγιος Νικόλαος",
    "Αθήνα",
    "Αλεξανδρούπολη",
    "Άμφισσα",
    "Άργος",
    "Άρτα",
    "Βέροια",
    "Βόλος",
    "Γρεβενά",
    "Δράμα",
    "Έδεσσα",
    "Ερμούπολη",
    "Ζάκυνθος",
    "Ηγουμενίτσα",
    "Ηράκλειο",
    "Θεσσαλονίκη",
    "Θήβα",
    "Ιωάννινα",
    "Καβάλα",
    "Καλαμάτα",
    "Καρδίτσα",
    "Κάρπαθος",
    "Καστοριά",
    "Κατερίνη",
    "Κέρκυρα",
    "Κιλκίς",
    "Κόρινθος",
    "Κοζάνη",
    "Κομοτηνή",
    "Λαμία",
    "Λάρισα",
    "Μυτιλήνη",
    "Ναύπλιο",
    "Ξάνθη",
    "Πάτρα",
    "Πειραιάς",
    "Πολύγυρος",
    "Πρέβεζα",
    "Πύργος", 
    "Ρέθυμνο",
    "Ρόδος",
    "Σάμος",
    "Σέρρες",
    "Σπάρτη",
    "Τρίκαλα",
    "Τρίπολη",
    "Φλώρινα",
    "Χαλκίδα",
    "Χανιά",
    "Χίος"
  ];

  export default greekCapitals;
  